import { LoadingProps } from '../../components/Loading/Loading';

const InitialLoading: LoadingProps = {
  loading: false,
};

export default InitialLoading;
